import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ReplaySubject, map, startWith } from 'rxjs';
import { BtnCellRenderer } from 'src/app/core/grid/btn-cell-render.component';
import { BoardsService } from 'src/app/service/boards.service';

@Component({
    selector: 'app-create-contingency',
    templateUrl: './create-contingency.component.html',
    styleUrls: ['./create-contingency.component.scss'],
    standalone: false ,  // NOSONAR
})
export class CreateContingencyComponent implements OnInit {
  gridApi: any;
  gridColumnApi: any;
  selectedRegions: { label: string; value: string }[]  = [];

  temp3: string;
  regionList: any;
  selectedRegionsTemp: any = [];

  temp4;
  periodData;

  selected_region;
  selected_period;
  rowData: any = [];

  selectedRegion;
  selectedDate;

  selected_region_Temp_final: any = [];
  regionFilterCtrl: FormControl = new FormControl();
  filteredRegions: ReplaySubject<{ label: string; value: string }[]> = new ReplaySubject(1);

  columnDefs;

  gridOptions;
  context;

  count = 0;


  successMessage = '';
  errorMessage = '';

  userID;
  usertemp: string;
  userInfo: any;
  selectedRegiontemp: any;
  obj:any;



  onGridReady(params: any) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
  }

  onaddRow() {

    console.info("selected", this.selected_region, this.selectedDate, this.selected_period);

    if (this.selected_region == undefined || this.selectedDate == undefined || this.selected_region == '') { // NOSONAR
      this.errorMessage = "Please fill in the required fields!";
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 6500);
    }

    else {



      // add data in DB

      // format cont date
      let dueYear;
      let cont;

      if (this.selectedDate) {


        dueYear = this.selectedDate.split('-');

        //  mm-dd-yyyy hh:mi
        cont = dueYear[1] + '-' + dueYear[2] + '-' + dueYear[0];

      }



      console.info("selecetd region", this.selected_region);
      this.selected_region.forEach(element => {

        this.selected_region_Temp_final.push(element.value);
      });

      this.selectedRegiontemp = this.selected_region_Temp_final.toString();


      const dateSplit = this.selectedDate.split('-');

      //  mm-dd-yyyy hh:mi
      const date = dateSplit[1] + '/' + dateSplit[2] + '/' + dateSplit[0];

      this.obj = {
        id: date, description: this.selectedRegiontemp , delete: ''
      };

      const dataArr = {

        "periodID": this.selected_period,
        "contingencyDate": cont,
        "regions": this.selectedRegiontemp
      }


      this.ngxUiLoaderService.start("loader-01");
      this.boardService.addContingencyTask(dataArr).subscribe(result => {

        console.info("result", result);

        if (!result) {
          this.errorMessage = 'Task already exists!';
          setTimeout(() => {
            this.successMessage = '';
            this.errorMessage = '';
          }, 6500);
          this.ngxUiLoaderService.stop("loader-01");
        }

        else if (result) {
          
          this.rowData.push(this.obj);

          sessionStorage.setItem('contData', JSON.stringify(this.rowData));

          this.successMessage = 'Task added successfully!';
          setTimeout(() => {
            this.successMessage = '';
            this.errorMessage = '';
          }, 6500);
          
          this.loadData();
          this.ngxUiLoaderService.stop("loader-01");

        }
      });


      //reset values
      this.selected_region_Temp_final = [];
      this.selected_region = '';
      this.selected_period = undefined;
      this.selectedDate = undefined;


    }


  }

  loadData() {

    if (sessionStorage.getItem('contData') != null) { // NOSONAR
      this.rowData = JSON.parse(sessionStorage.getItem('contData'));
    }
    else {
      this.rowData = [];
    }

    this.ngxUiLoaderService.stop("loader-01");
  }

  deleteContingencyRow(params) {

    console.info("params", params);

    this.rowData = this.rowData.filter(x => x != params.data); // NOSONAR

    sessionStorage.setItem('contData', JSON.stringify(this.rowData));

    // delete the data in DB


    const dataArr = {
      "contingencyDate": params.data.id,
      "regions": params.data.description
    }


    this.ngxUiLoaderService.start("loader-01");
    this.boardService.deleteContingenyRow(dataArr).subscribe(_result => {

      this.successMessage = 'Deleted Row(s) Successfully!';
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 6500);


      this.loadData();

    });


  }

  reset() {

    //reset values
    this.selected_region = undefined;
    this.selectedDate = undefined;
    this.selected_region_Temp_final = [];
  }

  constructor(private  readonly ngxUiLoaderService: NgxUiLoaderService, private readonly boardService: BoardsService) {

    this.context = {
      componentParent: this
    };

    this.columnDefs = [
      { headerName: "DATE", headerClass: "header_date", field: "id", width: 120, cellClass: "cell_idno", suppressSizeToFit: true },
      { headerName: "REGION", headerClass: "header_description", width: 440, field: "description", cellClass: "cell_description", suppressSizeToFit: true },
      {
        headerName: "ACTION", headerClass: "header_action", width: 120, field: "create_cont_action", cellClass: "cell_action",


        cellRenderer: BtnCellRenderer,
        cellRendererParams: {
          clicked: function (_field: any, _act: any) {
// do something

          }
        }

      }];

    this.loadData();


    this.ngxUiLoaderService.start("loader-01");


    //fetch from local-storage
    this.temp3 = localStorage.getItem('region-data');
    this.regionList = JSON.parse(this.temp3);

    this.regionList?.forEach(element => {
      

     const obj = { "label": element.region, "value": element.region_code };
      this.selectedRegionsTemp.push(obj);
    });

    this.selectedRegions = this.selectedRegionsTemp;


    //fetch from local-storage
    this.temp4 = localStorage.getItem('period-data');
    this.periodData = JSON.parse(this.temp4);

   

    const userData = sessionStorage?.getItem('FGA');
		if (userData) {
			this.userID = JSON.parse(userData)?.user?.userPrincipalName;
		}


    this.ngxUiLoaderService.stop("loader-01");

  }

  ngOnInit(): void {  
    this.regionFilterCtrl.valueChanges
    .pipe(
      startWith(''),
      map(search =>
        {
          if (search) {
            return this.filterRegions(search);
          }

          if (this.selectedRegions) {
            return this.selectedRegions.slice();
          }

          return [];
        }
      )
    )
    .subscribe(filtered => {
      this.filteredRegions.next(filtered);
    });
  }
  filterRegions(search: string): { label: string; value: string }[]  {
    // return filtered array
    return this.selectedRegions.filter(region =>
      region.label.toLowerCase().includes(search.toLowerCase())
    );
  
}
  isAllSelected(): boolean {
    return this.selected_region?.length == this.selectedRegions.length; // NOSONAR
  }
  
  isIndeterminate(): boolean {
    return this.selected_region?.length > 0 && !this.isAllSelected();
  }
  toggleSelectAll(event: any): void {
    if (event.checked) {
      this.selected_region = [...this.selectedRegions];
    } else {
      this.selected_region = [];
    }
  }
  addtask() {

    if (this.selected_period == undefined) { // NOSONAR
      this.errorMessage = "Please select the Period!";
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 6500);
    }

    else if (sessionStorage.getItem('contData') == null || sessionStorage.getItem('contData') == '[]') { // NOSONAR
      this.errorMessage = "Atleast one Contingency is required!";
      setTimeout(() => {
        this.successMessage = '';
        this.errorMessage = '';
      }, 6500);
    }

    else {
      // call service

      const dataArr = {
        "intuserID": this.userID,
        "periodID": this.selected_period

      };

      this.ngxUiLoaderService.start("loader-01");
      this.boardService.createContingencyTask(dataArr).subscribe(result => {

        console.info("result", result);

        if (!result) {
          this.errorMessage = 'Contingency Task already exists!';
          setTimeout(() => {
            this.successMessage = '';
            this.errorMessage = '';
          }, 6500);
          this.ngxUiLoaderService.stop("loader-01");
        }

        else if (result) {

          this.successMessage = 'Contingency Task Created successfully!';
          setTimeout(() => {
            this.successMessage = '';
            this.errorMessage = '';
          }, 6500);


          //reset cont data and period id.
          // clear contingency data
          sessionStorage.removeItem('contData');
          this.selected_period = undefined;
          this.loadData();

        }
      });

    }
  }

}
